import React from "react";

const AnalyticsIcon = ({ iconSize, strokeColor, className = "" }) => {

  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.03516 2.41211C11.5477 2.41211 13.5852 4.44961 13.5852 6.96211H9.03516V2.41211Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.96016 7.21133V4.48633C4.44766 4.48633 2.41016 6.52383 2.41016 9.03633C2.41016 11.5488 4.44766 13.5863 6.96016 13.5863C9.47266 13.5863 11.5102 11.5488 11.5102 9.03633H6.96016"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AnalyticsIcon;
